

























import { AcceptBlueToken } from '@futureecom/vue-payments'
import { useI18n } from 'vue-i18n-bridge'
import { defineComponent } from '@vue/composition-api'
import type { PropType } from '@vue/composition-api'
import type { PaymentAcceptBlue } from '@/types/plugins/AcceptBlue'
import type { Orderable, OrderableCheckout } from '@futureecom/futureecom-js/dist/services/cart-service'
import { useToasts } from '@/composable/useToasts'

export default defineComponent({
  name: 'AcceptBlueProvider',

  components: { AcceptBlueToken },

  props: {
    value: {
      type: Object as PropType<Orderable>,
      required: true,
    },
    checkout: {
      type: Object as PropType<OrderableCheckout>,
      required: true,
    },
    paymentMethod: {
      type: Object as PropType<PaymentAcceptBlue>,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n()
    const { addErrorToast } = useToasts()

    const inputStyle = `
        background: #fff;
        border: 1px solid;
        border-radius: 4px;
        border-color: #bbb3b9 #c7c1c6 #c7c1c6;
        box-sizing: border-box;
        font-family: 'ans-serif;
        font-size: 16px;
        line-height: 1;
        width: 100%;
        outline: 0;
        vertical-align: baseline;
        height: 50px;
        padding: 16px 8px;
      `

    return {
      t,
      inputStyle,
      addErrorToast,
    }
  },
})
